var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHalfStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.027 4.918 8.85 1.532c-.28-.806-1.42-.806-1.7 0L5.973 4.918a.3.3 0 0 1-.277.202l-3.585.073C1.258 5.21.906 6.294 1.586 6.81l2.857 2.166a.3.3 0 0 1 .106.326L3.51 12.733c-.247.817.676 1.487 1.376 1l2.943-2.048a.3.3 0 0 1 .342 0l2.943 2.047c.7.488 1.623-.182 1.376-.999L11.45 9.302a.3.3 0 0 1 .106-.326l2.857-2.166c.68-.516.328-1.6-.525-1.617l-3.584-.073a.3.3 0 0 1-.278-.202"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.7 1.5v9.206a.9.9 0 0 0 .347.711l2.95 2.294c.666.518 1.615-.084 1.43-.907l-.846-3.781a.3.3 0 0 1 .12-.312l2.955-2.06c.715-.499.374-1.622-.498-1.638l-3.783-.071a.3.3 0 0 1-.271-.184l-1.442-3.45C8.452.802 7.7.952 7.7 1.5"
})));
export default SvgHalfStar;